import _ from 'underscore'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import $appConfig from 'servicestack/config'
import templateUrl from 'emun.shopping.admin/site-dashboard.html'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'

class SiteDashboardController  {
    constructor(createAutoQuery, $session, $window, $state) {
        basicController(this)
        this.productImage = $appConfig.productImage;
        this.dateRanges = [
            {
                id: "Today",
                name: "Today"
            },
            {
                id: "Yesterday",
                name: "Yesterday"
            },
            {
                id: "Last7",
                name: "Last 7 days"
            },
            {
                id: "Last30",
                name: "Last 30 days"
            },
            {
                id: "YTD",
                name: "Year to Date"
            },
            {
                id: "Custom",
                name: "Custom"
            }
        ];
        this.dateRange = {
            id: "Today",
            name: "Today"
        };
        this.customRange = {
            startDate: new Date(),
            endDate: new Date()
        };
        this.vendors = createAutoQuery({
            url: 'QueryVendors.json',
            orderBy: 'VendorName',
            autoLoad: true,
            pageSize: 100,
            onLoaded: args => { if (args.results.count > 1) {this.vendor.id = this.$session.vendorId}}
        });
        this.vendor = {
            id: null
        }
        this.$session = $session;
    }
    load(){return this.query.load.apply(this.query, arguments);}
    downloadData() {
        let $ctrl = this;
        var url = "/service/QuerySiteDashboardSummary.csv?dateRange=" + $ctrl.dateRange.id;
        if ($ctrl.dateRange.id == "Custom") {
            url = url + "&startDate=" + $ctrl.customRange.startDate.toLocaleDateString("en-US") + "&endDate=" + $ctrl.customRange.endDate.toLocaleDateString("en-US");
        }
        return location.href = url;
    }
}

class SiteDashboard{
    constructor(){
        this.controller = SiteDashboardController;
    }
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.shopping.admin').component('siteDashboard', new SiteDashboard());

export default SiteDashboard